/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { TranslationDocumentSwagger, TranslationJobSwagger } from 'src/languageStudio/core/services/translation/translatorSwagger';
import { TranslationDocumentStore } from 'src/translation/stores/TranslationDocumentStore';
import { TranslationJobStore } from 'src/translation/stores/TranslationJobStore';

export const mapTranslationSwagger = (translationSwaggers: TranslationJobSwagger) =>
    new TranslationJobStore(translationSwaggers.id, {
        createdDateTimeUtc: new Date(translationSwaggers.createdDateTimeUtc ?? translationSwaggers.lastActionDateTimeUtc),
        lastActionDateTimeUtc: new Date(translationSwaggers.lastActionDateTimeUtc),
        status: translationSwaggers.status,
        documentsNumber: translationSwaggers.summary.success,
        error: translationSwaggers.error?.message
    });

export const mapTranslationDocumentsSwaggerArray = (translationDocumentsSwaggers: TranslationDocumentSwagger[]) => {
    const translationJobStores: TranslationDocumentStore[] = translationDocumentsSwaggers.map(swagger =>
        mapTranslationDocumentsSwagger(swagger)
    );
    return translationJobStores;
};

export const mapTranslationDocumentsSwagger = (translationDocumentsSwagger: TranslationDocumentSwagger) =>
    new TranslationDocumentStore(translationDocumentsSwagger.id, {
        createdDateTime: new Date(translationDocumentsSwagger.createdDateTimeUtc ?? translationDocumentsSwagger.lastActionDateTimeUtc),
        lastActionDateTime: new Date(translationDocumentsSwagger.lastActionDateTimeUtc),
        status: translationDocumentsSwagger.status,
        characterCharged: translationDocumentsSwagger.characterCharged,
        path: translationDocumentsSwagger.path,
        sourcePath: translationDocumentsSwagger.sourcePath,
        targetLanguageCode: translationDocumentsSwagger.to,
        progress: translationDocumentsSwagger.progress,
        error: translationDocumentsSwagger.error?.message
    });
